
export function convertSelectedVariantsToString(variants) {
  return Object.keys(variants).map(key => `${key}: ${variants[key]}`).join(', ')
}
